import { useEffect } from "react";

import { useSelectedLocation } from "components";
import { useTypedQuery } from "hooks";
import { CHECKLIST_TYPES } from "models";
import { PendingChecklistsQueryKeys } from "modules/PendingChecklistsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Checklist } from "models";

const selectChecklists = (checklists: Checklist[]) =>
  checklists.filter(c => c.active && !c.is_deleted && ![CHECKLIST_TYPES.ExtraParts, CHECKLIST_TYPES.Quality].includes(c.checklist_type));

export const useChecklistsQuery = () => {
  const { selectedLocation } = useSelectedLocation();

  const query = useTypedQuery({
    queryKey: PendingChecklistsQueryKeys.checklists,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { location_ids: [selectedLocation?.id], embed: "template" }, baseUrl)).data.checklists,
    select: selectChecklists,
    enabled: Boolean(selectedLocation?.id)
  });

  useEffect(() => {
    if (selectedLocation?.id) query.refetch();
  }, [selectedLocation?.id]);

  return query;
};
